import api from "./client";

// Feedback Loop System
export const recordPropertyFeedback = (data) => api.post("/feedback/property", data);
export const recordSupplierFeedback = (data) => api.post("/feedback/supplier", data);
export const recordSearchFeedback = (data) => api.post("/feedback/search", data);
export const recordOutreachOutcome = (data) => api.post("/feedback/outreach", data);
export const recordBookingOutcome = (data) => api.post("/feedback/booking", data);
export const getFeedbackDashboard = () => api.get("/feedback/analytics/dashboard");
export const getSupplierRankings = (limit) => api.get("/feedback/analytics/suppliers", { params: { limit } });
export const getChannelEffectiveness = () => api.get("/feedback/analytics/channels");
export const getPropertyPerformance = (limit) => api.get("/feedback/analytics/properties", { params: { limit } });
export const getFeedbackSummary = (days) => api.get("/feedback/analytics/summary", { params: { days } });
export const getSupplierRecommendations = (params) => api.get("/feedback/recommendations/suppliers", { params });
export const getChannelRecommendations = (enquiryId) => api.get("/feedback/recommendations/channels", { params: { enquiry_id: enquiryId } });

// Search Analytics
export const getSearchAnalytics = (days) => api.get("/analytics/search", { params: { days } });

// Financial Analytics
export const getFinancialsAnalytics = (days, date_basis = "invoice_due_date") => api.get("/analytics/financials", { params: { days, date_basis } });

// Deposit Reconciliation
export const getDepositReconciliation = () => api.get("/analytics/deposit-reconciliation");

// Negotiation Analytics
export const getNegotiationAnalytics = (days) => api.get("/analytics/negotiations", { params: { days } });

// Supplier Performance Analytics
export const getSupplierPerformance = (days) => api.get("/analytics/supplier-performance", { params: { days } });

// Monthly Reports
export const getMonthlyReport = (year, month, date_basis = "check_in") => api.get("/reports/monthly", { params: { year, month, date_basis } });
